import { mutations } from "@/store";

let nextId = 0;
function getId() {
  return (++nextId).toString();
}

const timeoutIds = {};

export default {
  async notificationAdd(
    { commit },
    { id = getId(), duration = 5000, ...notification }
  ) {
    commit(mutations.notificationAdd, { id, ...notification });
    if (duration) {
      clearTimeout(timeoutIds[id]);
      timeoutIds[id] = setTimeout(() => {
        commit(mutations.notificationDismiss, { id });
      }, duration);
    }
  },
  async notificationDismiss({ commit, state }, { id: idToRemove }) {
    const indexToRemove = state.notifications.findIndex(
      ({ id }) => id === idToRemove
    );
    if (indexToRemove > -1) {
      commit(mutations.notificationDismiss, { indexToRemove });
    }
  }
};
